'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresSelectPaymentOption]');

var WinresSelectPaymentOptionController = function () {
    function WinresSelectPaymentOptionController($scope, reservationService, cancelService) {
        _classCallCheck(this, WinresSelectPaymentOptionController);

        this.$scope = $scope;
        this.reservationService = reservationService;
        this.cancelService = cancelService;
    }

    _createClass(WinresSelectPaymentOptionController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.totalPrice = null;
            this.amount = this.context.amountToPay || null;
            this.onSelect();
            this.$scope.$watch(function () {
                return _this.context && _this.context.getTotalPrice();
            }, function (total, oldTotal) {
                return _this.onTotalPriceChange(total, oldTotal);
            });
        }
    }, {
        key: 'onTotalPriceChange',
        value: function onTotalPriceChange(total, oldTotal) {
            log('Total price changed from ' + oldTotal + ' to ' + total + '.');
            this.totalPrice = total;
            this.getPaymentOptions();
        }
    }, {
        key: 'onSelect',
        value: function onSelect() {
            log('Amount selected: ' + this.amount);
            this.context.setAmountToPay(this.amount);
        }
    }, {
        key: 'getPaymentOptions',
        value: function getPaymentOptions() {
            var _this2 = this;

            var data = this.context.getContext();
            if (this.promise) {
                this.cancelService.cancel(this.promise);
            }
            this.context.setAmountToPay(undefined);
            this.promise = this.reservationService.getPaymentOptionsWithResponse(data).then(function (response) {
                if (_.some(response.Options, function (x) {
                    return x.Amount == _this2.amount;
                })) {
                    // Suitable amount already selected.
                    log('Amount', _this2.amount, 'is already selected.');
                } else if (response.Options.length == 1) {
                    // Only one option available.
                    _this2.amount = response.Options[0].Amount;
                    log('Amount', _this2.amount, 'is the only option.');
                } else {
                    log('Old amount', _this2.amount, 'does not match any option.');
                    _this2.amount = null;
                }
                _this2.onSelect();
                return response.Options;
            });
        }
    }]);

    return WinresSelectPaymentOptionController;
}();

WinresSelectPaymentOptionController.$inject = ['$scope', 'reservationService', 'cancelService'];

_module3.default.component('winresSelectPaymentOption', {
    template: require('./winresSelectPaymentOption.html'),
    controller: WinresSelectPaymentOptionController,
    bindings: {
        context: '<',
        showLegend: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresSelectPaymentOption/winresSelectPaymentOption.js
// module id = 524
// module chunks = 2